/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as builder from '../../ducks/builder';

const styles = {
  legal: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '16px',
    // padding: '12px 24px',
    padding: '12px 0px',
    // backgroundColor: '#f4f4f4',
    fontSize: '12px',
    color: '#6b6b6b',
    flexWrap: 'wrap',
    textAlign: 'left',
  },
  logoWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  logoLink: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  logoImg: {
    width: '44px',
    height: '31px',
    objectFit: 'contain',
  },
  linksBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  linksRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  },
  link: {
    color: '#3f3f3f',
    textDecoration: 'none',
    fontSize: '12px',
    lineHeight: '16px',
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  divider: {
    color: '#9a9a9a',
    lineHeight: '16px',
  },
  copy: {
    color: '#8a8a8a',
    fontSize: '12px',
    lineHeight: '16px',
  },
};

class Footer extends React.Component {
  render() {
    const { footerClasses, intl } = this.props;
    const reservedRightsLabel = intl.formatMessage({
      id: 'Derechos Reservados',
    });
    const cookiePreferencesLabel = intl.formatMessage({
      id: 'Preferencias de cookies',
    });
    const copyrightYear = new Date().getFullYear();
    return (
      <div className="" style={{ borderTop: '1px solid #d9d9d9' }}>
        <div
          className={` kt-grid__item`}
          id="kt_footer"
          style={{ padding: '10px 0' }}
        >
          {/* <div className="kt-footer__bottom"> */}
          <div className={`${footerClasses} kt-container `}>
            <div className="m-footer_legal" style={styles.legal}>
              <div className="m-footer_legal--logo" style={styles.logoWrap}>
                <a
                  className="h-linkNoUnderline"
                  href="https://www.3M.com/"
                  aria-label="3M Logo - Opens in a new window"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.logoLink}
                >
                  <img
                    src="/media/logo-mobile-footer.png"
                    alt="3M Logo"
                    style={styles.logoImg}
                  />
                </a>
              </div>

              <div style={styles.linksBlock}>
                <div className="m-footer_legalLinks" style={styles.linksRow}>
                  {/* <a
                  href="/3M/es_AR/inicio/aviso-legal/"
                  className="m-footer_legalLink"
                  title="Aviso Legal"
                  aria-label="Aviso Legal"
                  target="_self"
                  style={styles.link}
                >
                  Aviso Legal
                </a> */}
                  {/* <div className="m-footer_legalSpan" style={styles.divider}>
                  |
                </div> */}
                  {/* <a
                  href="/3M/es_AR/inicio/politica-privacidad/"
                  className="m-footer_legalLink"
                  title="Política de Privacidad"
                  aria-label="Política de Privacidad"
                  target="_self"
                  style={styles.link}
                >
                  Política de Privacidad
                </a> */}
                  {/* <div className="m-footer_legalSpan" style={styles.divider}>
                  |
                </div> */}
                  <button
                    type="button"
                    className="js-gdprPrefs m-footer_legalLink"
                    title={cookiePreferencesLabel}
                    aria-label={cookiePreferencesLabel}
                    style={styles.link}
                    onClick={() => window.showConsentPreferencesPopup()}
                  >
                    {cookiePreferencesLabel}
                  </button>
                </div>
                <div className="m-footer_copyRight" style={styles.copy}>
                  {`© 3M ${copyrightYear}. ${reservedRightsLabel}`}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  footerClasses: builder.selectors.getClasses(store, {
    path: 'footer',
    toString: true,
  }),
});

export default injectIntl(connect(mapStateToProps)(Footer));
